export default __webpack_public_path__ + "static/media/ribboncuttin_w320.0a227d27.jpeg";